import { Link } from 'react-router-dom';
import { footerColumns, friendLinks, siteName } from '@/mocks/site';

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="mt-16 bg-primary-950 text-background-200">
      <div className="w-full px-4 py-14 md:px-8">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div>
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-primary-950">
                <i className="ri-movie-2-line text-xl" aria-hidden="true" />
              </span>
              <span className="font-heading text-lg font-bold text-background-50">{siteName}</span>
            </div>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-background-300">
              专注于电影与电视剧的资源展示与推荐，提供剧情介绍、演员资料与最新上映资讯，陪你把每个好故事看到最后。
            </p>
            <div className="mt-5 flex items-center gap-3">
              {['ri-wechat-line', 'ri-weibo-line', 'ri-youtube-line', 'ri-bookmark-3-line'].map((icon) => (
                <span
                  key={icon}
                  className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-900 text-background-200"
                >
                  <i className={`${icon} text-lg`} aria-hidden="true" />
                </span>
              ))}
            </div>
          </div>

          {footerColumns.map((column) => (
            <div key={column.title}>
              <h4 className="font-heading text-base font-semibold text-background-50">
                <span>{column.title}</span>
              </h4>
              <ul className="mt-4 flex flex-col gap-3">
                {column.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className="text-sm text-background-300 transition-colors hover:text-accent-400 cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 border-t border-primary-800 pt-6">
          <div className="flex flex-wrap items-center gap-x-3 gap-y-2 text-xs text-background-400">
            <span className="text-background-300">友情链接：</span>
            {friendLinks.map((link) => (
              <span key={link} className="whitespace-nowrap">
                {link}
              </span>
            ))}
          </div>
          <p className="mt-4 text-xs leading-relaxed text-background-400">
            © {year} {siteName} · 本站为影视资源展示演示平台，所有影片、演员及资讯信息均为示范数据，不提供在线播放服务。
          </p>
        </div>
      </div>
    </footer>
  );
}